'use client'

import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Thumbs } from 'swiper/modules'
import Image from 'next/image'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/thumbs'
import NotifyButton from '@/components/Product/NotifyButton/NotifyButton'
import { useDictionary } from '@/components/DictProvider/DictProvider'
import isImage from '@/lib/isImage'
import VideoPlayer from './VideoPlayer'
import useImageUrlModifier from '@/lib/useImageUrlModifier'

// `onImageClick` (optional): fires when the main image (not video) is
// tapped. ProductSlider passes fullScreenHandler here so mobile users
// get the same tap-to-fullscreen-swipe experience desktop has. Only
// fires on image slides so video controls aren't hijacked.
const SliderComponent = ({ images, fallbackImage, product, handleShare, onImageClick }) => {
  const modifyImageUrl = useImageUrlModifier();
  const [thumbsSwiper, setThumbsSwiper] = useState(null)
  const [activeIndex, setActiveIndex] = useState(0)
  const translate = useDictionary()
  return (
    <div className="w-full">
      {/* Main Active Image */}
      <div className="relative w-full overflow-hidden rounded-md md:border-2 md:border-secondary">
        {
          // product?.data?.stock > 0 ? 
          <Swiper
            modules={[Pagination, Thumbs]}
            thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
            onSlideChange={(swiper) => setActiveIndex(swiper?.realIndex)}
            className="w-full h-full"
          >
            {images.map((image, index) => (
              <SwiperSlide key={index} className="relative w-full aspect-square">
                <div
                  className="relative w-full aspect-square"
                  onClick={isImage(image) && onImageClick ? onImageClick : undefined}
                  role={isImage(image) && onImageClick ? "button" : undefined}
                  aria-label={isImage(image) && onImageClick ? "Open image gallery" : undefined}
                >

                  {isImage(image) ? <Image
                    src={modifyImageUrl(image, 500, 500) || fallbackImage}
                    alt={image}
                    fill={true}
                    priority
                    className="object-cover"
                    placeholder="blur"
                    blurDataURL={fallbackImage}
                    sizes="auto"
                  /> : <VideoPlayer
                    videoUrl={image}
                    play={false}
                    stock={product?.data?.stock === 0 ? true : false}
                    productId={product?.data?.id}
                  />}

                  {!(product?.data?.stock > 0) && <div className="w-full h-full absolute inset-0 bg-[#E0E0E0]/50 rounded-md p-4">
                    <div className=" relative inset-0 flex flex-col justify-between items-center  text-white font-semibold w-full h-full aspect-square text-center">
                      <p className="rounded-b-[6px] text-sm bg-[#555555] py-1 px-4">
                        {translate.poductDescriptionPage.outOfStock}
                      </p>
                      <div className="w-full flex justify-end">
                        <NotifyButton
                          productId={product?.data?.id}
                        />
                      </div>
                    </div>
                  </div>}

                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          // : 
          // <div className="relative w-full aspect-square">
          //   {isImage(images[0]) ? <>
          //     <Image
          //       src={modifyImageUrl(images[0], 500, 500) || fallbackImage}
          //       alt={images[0]}
          //       layout='responive'
          //       width={1}
          //       height={1}
          //       priority
          //       className="object-cover w-full aspect-square"
          //       placeholder="blur"
          //       blurDataURL={fallbackImage}
          //       sizes="auto"
          //     />
          //     <div className="w-full h-full absolute inset-0 bg-[#E0E0E0]/50 rounded-md p-4">
          //       <div className=" relative inset-0 flex flex-col justify-between items-center  text-white font-semibold w-full h-full aspect-square text-center">
          //         <p className="rounded-b-[6px] text-sm bg-[#555555] py-1 px-4">
          //           {translate.poductDescriptionPage.outOfStock}
          //         </p>
          //         <div className="w-full flex justify-end">
          //           <NotifyButton
          //             productId={product?.data?.id}
          //           />
          //         </div>
          //       </div>
          //     </div>
          //   </> : <VideoPlayer
          //     videoUrl={images[0]}
          //     play={false}
          //     stock={product?.data?.stock === 0 ? true : false}
          //     productId={product?.data?.id}
          //   />}

          // </div>

        }
        <div
          className="absolute right-0 top-0 z-[100] bg-[#EEEEEE]/50 p-1 rounded-md cursor-pointer"
          onClick={handleShare}
        >
          <Image
            src={"/images/shareIcon.svg"}
            width={28}
            height={28}
            alt="share"
          />
        </div>
        {!!product?.data?.bogo && !!product?.data?.sticker && (
          <div className="absolute z-10 bottom-0 right-0 m-3">
            <Image
              width={102}
              height={36}
              src={product?.data?.sticker?.replace(
                /^https:\/\/res\.cloudinary\.com/,
                "https://res.cloudinary.com"
              )}
              alt="bogo"
              className="object-contain"
            />
          </div>
        )}
      </div>

      {/* Thumbnail Slider */}
      {/* {product?.data?.stock > 0 &&  */}
      <div className="m-2 xs:mt-4">
        <Swiper
          onSwiper={setThumbsSwiper}
          spaceBetween={8}
          slidesPerView={6}
          freeMode={true}
          watchSlidesProgress={true}
          modules={[Thumbs]}
          className="thumbs-swiper"
        >
          {images.map((image, index) => (
            <SwiperSlide key={index} className="cursor-pointer">
              <div className={`relative w-full aspect-square pt-[100%] rounded-md overflow-hidden border-2 ${index === activeIndex ? 'border-primary' : 'border-secondary'
                }`}>
                {isImage(image) ? <Image
                  src={modifyImageUrl(image, 100, 100) || fallbackImage}
                  alt={image}
                  fill={true}
                  priority
                  className="object-cover"
                  placeholder="blur"
                  blurDataURL={fallbackImage}
                  sizes="auto"
                /> :
                  <div className="flex justify-center items-center">
                    <video
                      className="w-full aspect-square object-contain"
                      muted
                      controls={false}
                      autoPlay={false}
                      src={modifyImageUrl(image, 0, 0, true)}
                    />
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] flex items-center justify-center cursor-pointer"
                    >
                      <path
                        d="M9.5 15.5851V8.41714C9.50015 8.32745 9.52442 8.23946 9.57026 8.16238C9.61611 8.0853 9.68184 8.02197 9.76057 7.97902C9.83931 7.93608 9.92814 7.9151 10.0178 7.91828C10.1074 7.92147 10.1945 7.94871 10.27 7.99714L15.846 11.5801C15.9166 11.6254 15.9747 11.6876 16.0149 11.7612C16.0552 11.8348 16.0763 11.9173 16.0763 12.0011C16.0763 12.085 16.0552 12.1675 16.0149 12.2411C15.9747 12.3146 15.9166 12.3769 15.846 12.4221L10.27 16.0061C10.1945 16.0546 10.1074 16.0818 10.0178 16.085C9.92814 16.0882 9.83931 16.0672 9.76057 16.0243C9.68184 15.9813 9.61611 15.918 9.57026 15.8409C9.52442 15.7638 9.50015 15.6758 9.5 15.5861V15.5851Z"
                        fill="#ededed"
                      />
                      <path
                        d="M1 12C1 5.925 5.925 1 12 1C18.075 1 23 5.925 23 12C23 18.075 18.075 23 12 23C5.925 23 1 18.075 1 12ZM12 2.5C9.48044 2.5 7.06408 3.50089 5.28249 5.28249C3.50089 7.06408 2.5 9.48044 2.5 12C2.5 14.5196 3.50089 16.9359 5.28249 18.7175C7.06408 20.4991 9.48044 21.5 12 21.5C14.5196 21.5 16.9359 20.4991 18.7175 18.7175C20.4991 16.9359 21.5 14.5196 21.5 12C21.5 9.48044 20.4991 7.06408 18.7175 5.28249C16.9359 3.50089 14.5196 2.5 12 2.5Z"
                        fill="#ededed"
                      />
                    </svg>
                  </div>
                }
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {/* } */}
    </div>
  )
}

export default SliderComponent